/* unplugin-vue-components disabled */import { render } from "./openCardlist.vue?vue&type=template&id=3a7b5644&scoped=true"
import script from "./openCardlist.vue?vue&type=script&lang=js"
export * from "./openCardlist.vue?vue&type=script&lang=js"

import "./openCardlist.vue?vue&type=style&index=0&id=3a7b5644&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7b5644"]])

export default __exports__